import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import ThemeConsumer from "../ThemeConsumer"
import Typograph from "components/Typograph"

const CustomOption = ({ theme, ...props }) => {
  return <Option {...props}></Option>
}

CustomOption.propTypes = {
  theme: PropTypes.object
}

const Option = ThemeConsumer("UISelectMulti")(({ children, ...props }) => {
  const { innerRef, theme, innerProps, data } = props

  const onClickMultiOption = (e) => {
    props.selectOption({ ...data })
    e.stopPropagation()
    e.preventDefault()
  }

  const isAllOption = data.value === "SELECT_ALL"

  const classesContainer = classnames(
    "u-flex u-flexAlignItemsCenter",
    theme.mt3,
    theme.pointer,
    {
      [theme.containerOption]: !isAllOption,
      [theme.p3]: !isAllOption
    }
  )

  const typographProps = {
    size: isAllOption ? "small" : "medium",
    color: "metal_saurus",
    classNames: isAllOption ? theme.ml2 : theme.ml3
  }

  return (
    <div
      ref={innerRef}
      {...innerProps}
      {...props}
      onClick={onClickMultiOption}
      className={classesContainer}
    >
      <input type="checkbox" checked={props.isSelected} />
      <Typograph {...typographProps}>{children}</Typograph>
    </div>
  )
})

export default CustomOption



// WEBPACK FOOTER //
// ./src/shared/components/SelectMult/CustomOption.js